import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import {
  Item,
  Title,
  Subtitle,
  Price,
  IconWrapper,
  Counter,
  Summary,
  Publications,
  Description,
  IconTrash,
  TabItem,
  Subtotal,
  Day,
  Content
} from './styled';
import {
  PublicationModel,
  setPrintAllByChannel,
  deletePrintAllByChannel,
  setExtracharge,
  clearExtracharge,
  clearPhotoVignette,
  setPhotoVignetteAll
} from '@app/src/views/StepTwo/channelPublication';
import { DatePickerFeature } from '@app/src/common/datePicker';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { addDateSelectedAll, deleteAllDateSelected, setCalendarDate } from '@app/src/common/datePicker/state/calendar/actions';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORY, CATEGORIES } from '@app/src/config/categories';

interface Props {
  title?: string;
  day?: string;
  price?: number;
  priceIgv?: number;
  details?: PublicationModel[];
  idChannel?: number;
  idPackage?: number;
  printData?: any;
  handleClickItem?: Function;
  isCalendar?: boolean;
  priceSubTotal?: string;
  extra?: any;
  handleClickToggleCalendar?: Function;
}

const isClient = isClientEnv();

export const OptionChannel: React.FC<Props> = ({
  title,
  day,
  price,
  priceIgv,
  details,
  idChannel,
  idPackage,
  printData,
  handleClickItem,
  isCalendar,
  priceSubTotal,
  extra,
  handleClickToggleCalendar
}) => {
  const [ open, setOpen ] = useState(false);
  const dispatch = useDispatch();
  const channelTitle = `Clasificados ${title} - ${day}`;
  const publicationLabel = details && details.length == 1 ? 'Publicación' : 'Publicaciones';
  const idPrint = printData && printData.id;
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const print = useSelector(state => state.print);
  const category = useSelector(state => state.print.general.category);
  const categoryTheme = CATEGORIES[CATEGORY[category]];
  const [ extrachargeSelected, setExtrachargeSelected ] = useState([]);
  const extracharges = useSelector(state => state.extracharge.data[idPrint]);
  const printPhotoVignette = useSelector(state => state.print.photoVignette);

  useEffect(() => {
    if (printPhotoVignette && Object.keys(printPhotoVignette).length > 0) {
      dispatch(setPhotoVignetteAll(printPhotoVignette));
    }
  }, [printPhotoVignette]);

  useEffect(() => {
    if (print && print.extracharges && print.extracharges[idChannel] && print.extracharges[idChannel].data && print.extracharges[idChannel].data.length > 0) {
      dispatch(setExtracharge(idChannel, print.extracharges[idChannel].data));
    } else {
      if (extra && idChannel && extra[idChannel] && extra[idChannel].data) {
        dispatch(setExtracharge(idChannel, extra[idChannel].data));
      } else {
        dispatch(setExtracharge(idChannel, printData.extracharge));
      }
    }
  }, []);

  useEffect(() => {
    if (extracharges && extracharges.data && extracharges.data.length > 0) {
      const selecteds = extracharges.data.filter(item => (item.checked === true));
      setExtrachargeSelected(selecteds);
    }
  }, [extracharges]);

  const handleAddDay = useCallback(
    (date: DateSelectedType) => dispatch(addDateSelectedAll(date, printData.id)),
    [dispatch]
  );

  const handleClickOpen = () => {
    handleClickItem && handleClickItem();
    const dateSelected = printsByChannel[idChannel];
    handleSetCalendarDate();
    if (dateSelected && dateSelected.length > 0) {
      handleAddDay(dateSelected);
    }
    setOpen(!open);
  };

  const handleSetCalendarDate = useCallback(
    () => dispatch(setCalendarDate(printData)),
    [dispatch]
  );

  const handleClickDelete = useCallback(() => {
    const isDiscard = confirm('Todos los cambios se borrarán, ¿desea seguir con la acción?');
    if (isDiscard) {
      dispatch(deletePrintAllByChannel(idChannel));
      dispatch(clearPhotoVignette(idChannel));
      dispatch(deleteAllDateSelected(idChannel));
      dispatch(clearExtracharge(idChannel));
      isClient && sessionStorage.setItem('print', JSON.stringify(print));
    }
  }, [extracharges, printsByChannel]);

  const handleClickBack = () => {
    setOpen(!open);
  };

  const handleClickNext = (data: any) => {
    getDataForPayment(data);
    setConfigForDatalayer(data.printDate);
    setOpen(!open);
  };

  const handleClickOutSide = (toogle: boolean, data) => {
    getDataForPayment(data);
    setConfigForDatalayer(data.printDate);
    setOpen(toogle);
    handleClickToggleCalendar && handleClickToggleCalendar(data);
  };

  const setConfigForDatalayer = (datesSelecteds) => {
    if (datesSelecteds && datesSelecteds.length > 0) {
      const dates = datesSelecteds.map(item => `${getZeroFormatDate(item.dayMonth)}-${getZeroFormatDate(item.month + 1)}-${item.year}`);
      pushDatalayerDates(`Paso 2.b - ${categoryTheme.name}`, dates);
      const extrachargesName = formatExtracharges();
      if (extrachargesName && extrachargesName.length > 0) {
        pushDatalayerDates(`Paso 2.c - ${categoryTheme.name}`, extrachargesName);
      }
    }
  };

  const pushDatalayerDates = (eventAction: string, names: string[]) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': eventAction,
        'eventLabel': names.join('|'),
        'eventValue': 1
      });
    }
  };

  const formatExtracharges = () => extracharges && extracharges.data && extracharges.data.length > 0 && extracharges.data.filter(item => item.checked).map(item => item.name);

  const getDataForPayment = useCallback((data: any) => {
    const arrDetails = hydrateChannelData(data);
    dispatch(setPrintAllByChannel(String(data.id), arrDetails));
  }, [extracharges]);

  const hydrateChannelData = (data: any): any => {
    return data.printDate.map(item => ({
      dayMonth: item.dayMonth,
      fullDate: item.fullDate,
      month: item.month,
      year: item.year,
      publicationId: idChannel,
      packageId: idPackage,
      price,
      priceIgv,
      datePrint: `${item.year}-${getZeroFormatDate(item.month + 1)}-${getZeroFormatDate(item.dayMonth)}`,
      dateFormat: `${item.fullDate} ${item.year}`
    }));
  };

  const getZeroFormatDate = (date: number) => {
    if (date <= 9) {
      return `0${date}`;
    }
    return date;
  };

  return(
    <Item>
      <TabItem onClick={handleClickOpen}>
        <Title>{`Clasificados ${title}`}{day && <Day> - {day}</Day>}</Title>
        <Subtitle>Precio por publicación desde <Price>{`S/ ${priceIgv}`}</Price></Subtitle>
        <IconWrapper>
            {details && details.length > 0 && <Counter color={categoryTheme && categoryTheme.color}>{details.length}</Counter>}
            <Icon data-name="icon-expand-more" fill={COLORS.GRAY_PLACEHOLDER} width="9" height="9" />
        </IconWrapper>
      </TabItem>
      {
        isCalendar &&
          <DatePickerFeature
            title={channelTitle}
            priceAside={priceIgv}
            open={open}
            handleClickOutSide={handleClickOutSide}
            printData={printData}
            handleClickNext={handleClickNext}
            handleClickBack={handleClickBack}
            categoryId={category}
          />
      }
      {
        details && details.length > 0 &&
        <Summary>
          <Publications>{details.length} {publicationLabel}</Publications>
          <Content>
          {details && details.map((item, index) => (
            <Description key={index}>{item.dateFormat}</Description>
          ))}
          </Content>
          {
            extrachargeSelected && extrachargeSelected.length > 0 &&
            <React.Fragment>
              <Publications>Extracargos</Publications>
              <Content>
                {
                  extrachargeSelected.map((item, index) => (
                    <Description key={index}>{item.name} x {details.length}</Description>
                  ))
                }
              </Content>
            </React.Fragment>
          }
          <Subtotal>Sub Total S/ {priceSubTotal}</Subtotal>
          <IconTrash onClick={handleClickDelete}>
              <Icon data-name="icon-trash" fill={COLORS.GRAY_DARK} width ="16" height="16" />
          </IconTrash>
        </Summary>
      }
    </Item>
)};
